var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "upscard color-black",
      attrs: { href: _vm.product.url },
      on: {
        mouseover: function($event) {
          _vm.hovered = true
        },
        mouseleave: function($event) {
          _vm.hovered = false
        }
      }
    },
    [
      _c("div", { staticClass: "flex-row space-between align-start" }, [
        _c("h3", { staticClass: "strong-medium body-md upscard__title" }, [
          _vm._v(
            _vm._s(_vm.heading || "Complete this Set: " + _vm.product.title)
          )
        ]),
        _c("span", [
          _c(
            "span",
            {
              staticClass: "upscard__price strong-medium body-md",
              class:
                ((_obj = {}),
                (_obj[_vm.$store.state.comparePriceColor] =
                  _vm.product.price < _vm.product.compare_at_price),
                _obj)
            },
            [_vm._v(_vm._s(_vm._f("moneyWithoutDecimals")(_vm.product.price)))]
          ),
          _vm.product.compare_at_price > _vm.product.price
            ? _c("s", { staticClass: "body-md color-grey" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("moneyWithoutDecimals")(_vm.product.compare_at_price)
                  )
                )
              ])
            : _vm._e()
        ])
      ]),
      _c("p", {
        staticClass: "body-sm",
        domProps: {
          innerHTML: _vm._s(
            _vm.truncate100(
              _vm.stripHtml(_vm.description || _vm.product.description)
            )
          )
        }
      }),
      _c(
        "div",
        { staticClass: "flex-row space-between align-center" },
        [
          _c(
            "span",
            {
              staticClass: "body-md strong-bold",
              class: _vm.$store.state.comparePriceColor
            },
            [_vm._v(_vm._s(_vm.callout || "Special Value!"))]
          ),
          _c(
            "v-arrow-button",
            {
              class: { "button--hover": _vm.hovered },
              attrs: { primary: true }
            },
            [_c("icon", { attrs: { name: "arrow-right", size: "16px" } })],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }